import { rtrim } from "../util/utils";

export default class ColorSelector {
  constructor() {
    if ( ColorSelector.exists ) {
      return ColorSelector.instance;
    }
    ColorSelector.instance = this;
    ColorSelector.exists = true;

    this.variationsForm = document.querySelector( '.variations_form' );
    if ( ! this.variationsForm ) {
      return;
    }

    this.selectors = this.variationsForm.querySelectorAll( '.product-variable__block' );
    this.attributeElems = this.variationsForm.querySelectorAll( 'select' );
    this.addHandlers();
  }

  addHandlers() {
    this.attachListeners();
    this.attributeElems.forEach( this.attributes.bind( this ) );
    // document.body.addEventListener( 'palram_attribute_changed', this.onAttributeChange.bind( this ) );
    // window.addEventListener( 'locationchange', event => {
    //   let urlSearch = event.target.location.search;
    //   this.findQuery( urlSearch );
    // } );
  }

  attachListeners() {
    if ( this.selectors ) {
      this.selectors.forEach( selector => {
        if ( selector.dataset.attribute ) {
          selector.addEventListener( 'change', this.triggerVariationChange.bind( this ) );
        }

        $( this.variationsForm ).on( 'woocommerce_update_variation_values', () => {
          let inputs = this.variationsForm.querySelectorAll( '.color-checkbox__input' );

          if ( inputs ) {
            inputs.forEach( input => {
              let option = this.variationsForm.querySelector( `select[name="${ input.name }"] option[value="${ input.value }"]` );
              input.setAttribute( 'disabled', 'disabled' );
              input.classList.add( 'disabled' );

              if ( option && option.disabled === false ) {
                input.removeAttribute( 'disabled' );
                input.classList.remove( 'disabled' );
              }
            } );
          }
        } );
      } );
    }
  }

  triggerVariationChange( event ) {
    let el = event.target;
    let attribute = el.name;

    if ( ! el.classList.contains( 'color-checkbox__input' ) && ! el.dataset.triggerVariation ) {
      return;
    }

    ColorSelector.triggerVariation( el, attribute );
  }

  attributes( attribute ) {
    const value = attribute[ attribute.selectedIndex ].value;
    const field = this.getAttributeFieldName( attribute.name );
    attribute.addEventListener( 'change', this.onChangeAttribute.bind( this ) );

    this.setAttributeQuery( field, value );
  }

  onChangeAttribute( event ) {
    const value = event.target.value;
    const field = this.getAttributeFieldName( event.target.name );

    this.setAttributeQuery( field, value );
  }

  setAttributeQuery( fields, value ) {
    let url = window.location.pathname;
    const oldQuery = window.location.search;
    let params = new URLSearchParams( oldQuery );

    if ( params.has( fields ) ) {
      params.set( fields, value );
    } else {
      params.append( fields, value );
    }

    if ( params ) {
      url += `?${ params }`
    }

    url = rtrim( url, '?' );

    window.history.replaceState( {}, "", decodeURIComponent( url ) );
  }

  getAttributeFieldName( name ) {
    return name.replace( 'pa_', '' );
  }

  // findQuery( query ) {
  //   if ( query === 'undefined' ) {
  //     return;
  //   }
  //
  //   let pair = [], i, max;
  //   const urlData = query.substring( 1 );
  //   const vars = urlData.split( '&' );
  //   const inputs = this.attributeElements;
  //
  //   for( i = 0, max = vars.length; i < max; i++ ) {
  //     pair = vars[ i ].split( '=' );
  //     const queryName = pair[ 0 ];
  //     const queryValue = pair[ 1 ];
  //     if ( queryName && queryValue ) {
  //       inputs.forEach( input => {
  //         if ( queryName === input.name && queryValue === input.value ) {
  //           input.click();
  //         }
  //       } );
  //     }
  //   }
  // }

  static triggerVariation( selector, attribute ) {
    const variationForm = document.querySelector( 'form.variations_form' );
    let selects = variationForm.querySelectorAll( 'select' );

    selects.forEach( select => {
      if ( attribute === select.name ) {
        select.value = selector.value;
        select.dispatchEvent( new Event( 'change', { bubbles: true } ) );
      }
    } );
  }
}
